<template>
    <div class="sports-search-modal">
        <div class="modal fade" id="searchModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="input-search-box-modal">
                        <input  type="text" placeholder="Search Events" @input="searchCasinoMatches" v-model="searchText" class="form-control">
                        <img src="@/assets/images/search.png" alt="" class="sport-search-icons">
                        <button ref="dismissSearch" type="button" data-bs-dismiss="modal"  @click.prevent="resetField()" class="sports-close-icons">
                            <img src="@/assets/images/close.png" alt="">
                        </button>
                    </div>
                    <div class="modal-body p-0">
                        <div class="sports-wrapper">
                            <div class="scrollSearchBox">
                                <ul v-if="searchResult && searchResult.matches && searchResult.matches.length > 0" class="search-game-ul">
                                    <li v-for="(searchItem, sIndex) in searchResult.matches" :key="sIndex">
                                        <a @click="gotoEvent(searchItem)">
                                            <div class="d-flex justify-content-between w-100">
                                                <div class="search-game-name d-flex"><b>{{ capitalizeFirstLetter(searchItem?.sport_name) }} | {{ searchItem.league_name }}</b>
                                                </div>
                                                <div class="text-end">{{ formatDate(searchItem?.event_date) }}&nbsp;{{ formatTime(searchItem?.event_date) }}</div>
                                            </div>
                                            <div class="game-teams w-100">{{ searchItem.event_name }}
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                                <ul v-else-if="searchResult && searchText && searchResult.matches.length === 0" class="search-game-ul">
                                    <li >
                                    <div class="game-teams w-100 not-found">
                                        No Items Found
                                    </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../../services/api';
import * as apiName from '../../services/urls';
import { AUTH_TOKEN } from "@/shared/constants/cookies-const";
import moment from 'moment';

export default {
    name: 'SearchModal',
    data() {
        return {
            searchResult: null,
            searchText: ""
        }
    },
    mounted() {
        const modalElement = document.getElementById('searchModal');
        modalElement.addEventListener('hidden.bs.modal', this.resetField);
    },
    beforeUnmount() {
        const modalElement = document.getElementById('searchModal');
        modalElement.removeEventListener('hidden.bs.modal', this.resetField);
    },
    methods: {
        capitalizeFirstLetter(value) {
        if (value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
        return '';
      },
        resetField() {
            this.searchText = '';
            this.searchResult = null;
        },
        searchCasinoMatches() {
            try {
                if (!this.searchText || this.searchText.length <= 2) {
                    this.searchResult = null;
                    return;
                }

                this.searchResult = null;
                this.$store.dispatch('setGlobalLoader', true);

                let headers = {
                    'Authorization': `Bearer ${this.$cookies.get(AUTH_TOKEN)}`,
                    'Content-Type': 'application/json' 
                };
                let data = {
                    "search": this.searchText
                };

                api.post(apiName.SEARCH, data, { headers })
                    .then(response => {
                        this.$store.dispatch('setGlobalLoader', false);
                        if (response && response.status === 200) {
                            let resData = response.data.data ?? null;
                            this.searchResult = resData;
                        } 
                    })
                    .catch(error => {
                        this.$store.dispatch('setGlobalLoader', false);
                        this.showErrorModalFunc(error[0]);
                    });
            } catch (error) {
                this.showErrorModalFunc(error[0]);
            }
},
        formatTime(date) {
            return moment(date).format('hh:mm A');
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        },
        isTomorrow(date) {
            let eventDate = moment(date);
            let tomorrowDate = moment().add(1, 'day').startOf('day');
            return eventDate.isSame(tomorrowDate, 'day');
        },
        isToday(date) {
            let eventDate = moment(date);
            let todayDate = moment().startOf('day');
            return eventDate.isSame(todayDate, 'day');
        },
        gotoEvent(item) {
            this.$router.push({ name: 'sports-event-detail', params: { event_id: item.event_id } });
            this.$refs.dismissSearch.click();
        }
    }

}
</script>
<style scoped>
.not-found {
    font-size: 14px;
    color: #d3d3d3;
    padding: 10px;
    padding-top: 5px;
    font-weight: 300;
}
</style>